<template>
  <div class="coreinfo" v-if="req.type == 'CoreRequirement'">
    <requirement
      ref='coreRequirement'
      :req="req.core"
    ></requirement>
  </div>
  <div class="requirement" v-else>
    <degree-requirement
      v-if="req.type == 'DegreeRequirement'"
      ref="degreeRequirement"
      :req="req"
    ></degree-requirement>
    <course
      v-if="req.type == 'CourseRequirement'"
      ref='courseRequirement'
      :req="req"
    ></course>
    <wildcard
      v-if="req.type == 'WildCardRequirement'"
      ref='wildCardRequirement'
      :req="req"
    ></wildcard>
  </div>
</template>

<script>
  import DegreeRequirement from './degree_requirement.vue'
  import Course from './course_requirement.vue'
  import Wildcard from './wild_card_requirement.vue'

  export default {
    name: 'requirement',

    props: {
      req: true
    },

    components: {
      DegreeRequirement,
      Course,
      Wildcard
    },

    methods: {
      mainRef() {
        return this.$refs.coreRequirement || this.$refs.degreeRequirement ||
               this.$refs.courseRequirement || this.$refs.wildCardRequirement
      },

      nestedRef() {
        return this.$refs.degreeRequirement || this.$refs.coreRequirement
      },

      setCollapseState(state) {
        const ref = this.nestedRef()
        if (ref) ref.setCollapseState(state)
      },

      computeMinimumCredits() {
        const ref = this.mainRef()
        return ref ? ref.computeMinimumCredits() || 0 : 0
      }
    }
  }
</script>



// WEBPACK FOOTER //
// requirement.vue?41c7102a